// extracted by mini-css-extract-plugin
module.exports = {"container":"EditorialQuote_container__zOdr0","quote":"EditorialQuote_quote__BudHp","quotee":"EditorialQuote_quotee__t5Bl8"};